import { useEffect } from 'react';
import { useHTTP } from 'hooks/useRequest';
import { groupActions } from './approvals_group_reducer';

const useInititalLoadRequest = (
  editMode,
  initialLoadUrl,
  editGroupUrl,
  inititalLoadRequest,
  approvalGroupDispatch,
) => {
  const requestUrl = editMode ? editGroupUrl : initialLoadUrl;

  const requestConfig = {
    method: 'get',
    url: inititalLoadRequest ? requestUrl : null,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };

  const { data } = useHTTP(requestConfig);

  useEffect(() => {
    if (!data) return;

    const {
      description: {
        validation_rules: { max_length: descriptionMaxLength },
      },
      name: {
        validation_rules: { max_length: nameMaxLength },
      },
    } = data.approval_group;

    const [
      { administrator: adminsCount },
      { standard: usersCount },
      { approver: approversCount },
    ] = data.account_user_count;

    approvalGroupDispatch({
      type: groupActions.INITIAL_LOAD_REQUEST,
      payload: {
        nameMaxLength,
        descriptionMaxLength,
        adminsCount,
        approversCount,
        usersCount,
      },
    });

    if (editMode) {
      // Add group details and users from request

      const { name, description } = data.approval_group;

      approvalGroupDispatch({
        type: groupActions.NAME_INPUT,
        payload: name.value ? name.value : '',
      });

      approvalGroupDispatch({
        type: groupActions.INITITAL_GROUP_NAME,
        payload: name.value ? name.value : '',
      });

      approvalGroupDispatch({
        type: groupActions.DESCRIPTION_INPUT,
        payload: description.value ? description.value : '',
      });

      const { administrator, approver, standard } = data.approval_group_users;

      approvalGroupDispatch({
        type: groupActions.UPDATE_ALL_ADMINS,
        payload: administrator,
      });

      approvalGroupDispatch({
        type: groupActions.UPDATE_ALL_APPROVERS,
        payload: approver,
      });

      approvalGroupDispatch({
        type: groupActions.UPDATE_ALL_USERS,
        payload: standard,
      });
    }
  }, [data]);
};

export default useInititalLoadRequest;
